import i18n from "config/i18next";

i18n.addResources("es", "editPresettlement", {
  preliquidationNumber: "Número de la preliquidación",
  status: "Estado",
  dateOfIssue: "Fecha de generación",
  instruction: "Ingresá el nuevo monto de la preliquidación",
  actualAmount: "Monto actual",
  amountToAdd: "¿Cuánto querés sumarle? *",
  amountToSubstract: "¿Cuánto querés restarle? *",
  reasonLabel: "Motivo *",
  amount: "Ingresá el monto",
  reasonPlaceholder: "Ingresá el motivo de la modificación",
  add: "Sumar un monto",
  subtract: "Restar un monto",
  amountExceededError: "El monto excede el límite",
  unsavedChangesTitle: "Guardá tus cambios",
  unsavedChangesMessage: "Si te vas sin guardar, tus cambios no van a quedar registrados.",
  goToSave: "Ir a guardar",
  dontSave: "No quiero guardarlos",
});

i18n.addResources("es_MX", "editPresettlement", {
  unsavedChangesTitle: "Guarda tus cambios",
  unsavedChangesMessage: "Si te vas sin guardar, tus cambios no quedarán registrados.",
  goToSave: "Ir a guardar",
  dontSave: "No quiero guardarlos",
});

i18n.addResources("es_CL", "editPresettlement", {
  unsavedChangesTitle: "Guarda tus cambios",
  unsavedChangesMessage: "Si te vas sin guardar, tus cambios no quedarán registrados.",
  goToSave: "Ir a guardar",
  dontSave: "No quiero guardarlos",
});

i18n.addResources("es_CO", "editPresettlement", {
  unsavedChangesTitle: "Guarda tus cambios",
  unsavedChangesMessage: "Si te vas sin guardar, tus cambios no quedarán registrados.",
  goToSave: "Ir a guardar",
  dontSave: "No quiero guardarlos",
});
